export default "__VITE_ASSET__6b32dbaa__"